export class CloudResourceConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "CloudResourceConfigurationCdcBackup",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "CloudResourceConfigurationInventoryBackup",
            "format": ""
        },
        {
            "name": "dbBackupModeCdc",
            "baseName": "dbBackupModeCdc",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcpSqlVmBackupSettings",
            "baseName": "gcpSqlVmBackupSettings",
            "type": "GcpSqlVmBackupSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudResourceConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
